import React from 'react'
import Icons from '../../components/Icons'
import styled from 'styled-components'
import {_L, useLocaleState} from '../../context/LocaleContext'

export const MeetingRoomFooter = ({onBook}) => {
  const localeState = useLocaleState()
  return (
    <Container>
      <StyledButton onClick={onBook}>
        {_L({key: 'Book', localeState})}
        <ButtonIcon>
          <Icons icon="CHECK" />
        </ButtonIcon>
      </StyledButton>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 30px 30px 0 30px;
`

const StyledButton = styled.button`
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  color: #ffffff;
  flex: 1;
  height: 56px;
  border: none;
  border-radius: 4px;
  background-color: #3395fe;
  
  @media (max-width: 420px) {
    height: 48px;
  }
`

const ButtonIcon = styled.span`
  margin-left: 10px;
`
